import React from 'react';
import { PromotionSectionItem } from '../styled';
import { ItemIcon, ItemPrice, ItemTitle, NotAuthorContent } from './styled';
import Icon from '../../../../../Icon';
import { PromotionServiceId } from '../../../../../types/promotion';
import { PromotionButtonProps } from '../../types';

const promotionButtonStat = {
  [PromotionServiceId.Bump]: 'product-service-bump',
  [PromotionServiceId.Vip]: 'product-service-vip',
  [PromotionServiceId.Feature]: 'product-service-featured'
};

export const PromotionButton: React.FC<PromotionButtonProps> = ({
  title,
  icons,
  price,
  onClickHandler,
  isAuthor,
  id
}) => (
  <PromotionSectionItem
    onClick={onClickHandler}
    $isAuthor={isAuthor}
    data-cy={`prom-section__item${isAuthor ? '' : '--not-author'}`}
    data-stat={promotionButtonStat[id]}
  >
    <NotAuthorContent>
      <ItemTitle
        tag="title_5"
        data-cy="prom-section__item-content--not-author-title"
      >
        {title}
      </ItemTitle>
      <ItemPrice
        tag="caption_2"
        data-cy="prom-section__item-content--not-author-price"
      >
        {price}
      </ItemPrice>
    </NotAuthorContent>

    <ItemIcon data-cy="prom-section__item-content--not-author-icon">
      <Icon
        indent={false}
        width={18}
        height={16}
        IconComponent={icons.length > 1 ? icons[2] : icons[0]}
      />
    </ItemIcon>
  </PromotionSectionItem>
);
